import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=16208d94&"
import script from "./EmptyState.vue?vue&type=script&lang=ts&"
export * from "./EmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports